import React from 'react';
import { Box, useTheme } from '@mui/material';
import BookingNotification from './BookingNotification';
import { useNavigate } from 'react-router-dom';

/**
 * BookingNotificationContainer - Container for booking notifications
 * Displays notifications in a stack on the right side top
 * 
 * @param {Object} props
 * @param {Array} props.notifications - Array of booking notification objects
 * @param {Function} props.onRemove - Callback when notification is removed
 */
const BookingNotificationContainer = ({ notifications, onRemove }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNotificationClick = (booking) => {
    const safeBookingId = Number(booking?.id || booking?.booking_id);
    if (Number.isInteger(safeBookingId) && safeBookingId > 0) {
      navigate(`/booking/detail/${safeBookingId}/`);
      onRemove(safeBookingId);
    }
  };

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80, // Below header
        right: 16,
        zIndex: 1300, // Above drawer (1200) but below modal (1400)
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        maxHeight: 'calc(100vh - 100px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.2)' 
            : 'rgba(0, 0, 0, 0.2)',
          borderRadius: '3px',
          '&:hover': {
            background: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.3)' 
              : 'rgba(0, 0, 0, 0.3)',
          },
        },
      }}
    >
      {notifications.map((booking, index) => (
        <BookingNotification
          key={booking.id || index}
          booking={booking}
          open={true}
          onClose={() => onRemove(booking.id)}
          onClick={() => handleNotificationClick(booking)}
        />
      ))}
    </Box>
  );
};

export default BookingNotificationContainer;
